import React from 'react';
import { Label, List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { dateFormatter, formatDate } from '@/utils/dateHelper';
import { approvalStatus } from '../constants';
import { resolveRequestWorkflow } from '../state/state';

const RequestTransferredOnListItem = ({ transferDates, status }) => {
  if (status !== approvalStatus.APPROVE || !transferDates.length) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-transferred-on-list-item">
      <List.Header>
        <FormattedMessage id="request.list.transferred.at.title" />
      </List.Header>
      <Label.Group
        className="aridhia-request-transferred-on-label-group aridhia-h4 aridhia-tag"
      >
        {transferDates.map((transferDate) => (
          <Label
            key={`request_transfer_date_${transferDate.transferred_at}`}
            content={dateFormatter(transferDate.transferred_at)}
            title={formatDate(transferDate.transferred_at)}
          />
        ))}
      </Label.Group>
    </List.Item>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(
    requests,
    workflows,
    ownProps,
    { status: '', transfer: { transfer_dates: [] } },
  );

  return ({
    status: request.status,
    transferDates: request.transfer.transfer_dates,
  });
};

export default connect(mapStateToProps)(RequestTransferredOnListItem);
